<template>
  <div>
    <div class="table-section">
      <el-card class="box-card" shadow="never">
        <el-form
          :inline="true"
          :model="params"
          class="demo-form-inline"
          label-width="80px"
        >
          <el-form-item label="委案时间">
            <el-date-picker
              v-model="date"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="lastBindAgentTimeChange"
            />
          </el-form-item>
          <el-form-item label="操作人">
            <el-select
              v-model="operator"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="操作人"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in operatorList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账龄">
            <el-select v-model.trim="params.accountsAge" placeholder="账龄">
              <el-option
                v-for="dict in fdAccountsAgeList"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportFun">导出</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { exportoutsourcedTasks } from "@/api/reportExport";
import { getDictionaryList, getUser } from "@/api/manage";

export default {
  name: "download",
  data() {
    return {
      headerRowStyle: {
        "background-color": "#6584b4",
      },
      params: {},
      fdAccountsAgeList: [],
      operator: "",
      operatorList: [],
      loading: false,
      date: []
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  async created() {
    // 账龄
    const fdAccountsAgeRes = await getDictionaryList("fd_accountsAge");
    fdAccountsAgeRes.data.map((item) => {
      this.fdAccountsAgeList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
  },
  methods: {
    // 操作人
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          const getUserRes = await getUser(query, 10);
          this.loading = false;
          if (getUserRes.data.length > 0) {
            getUserRes.data.map((item) => {
              this.operatorList.push({
                label: item.name,
                value: item.id,
              });
            });
          }
        }, 200);
      } else {
        this.operatorList = [];
      }
    },
    lastBindAgentTimeChange(val) {
      if (val && val.length) {
        this.params.lastBindAgentTimeStart = val[0];
        this.params.lastBindAgentTimeEnd = val[1];
      } else {
        this.params.lastBindAgentTimeStart = "";
        this.params.lastBindAgentTimeEnd = "";
      }
    },
    /**
     * 导出
     */
    async exportFun() {
      if (this.operator.length > 0) {
        this.params.operator = this.operator.join(",")
      } else {
        this.params.operator = ""
      }
      const exportoutsourcedTasksRes = await exportoutsourcedTasks(this.params);
      this.$message.success(exportoutsourcedTasksRes.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.table-section {
  margin-top: 20px;
}
</style>
